import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom-v5-compat';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';

/**
 * useRedirectIfLoggedIn
 *
 * Effect hook that runs on mount. If logged in, redirect the user to the
 * set location in state if possible, or fall back to a default.
 */
export default function (destination = '/dashboard'): void {
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from;

  useEffect(() => {
    if (SessionClientDashboard.isLoggedIn()) {
      navigate(typeof from === 'string' ? from : destination, { replace: true });
    }
  }, []);
}
